import { queryOptions } from '@tanstack/react-query';

import { fetchDraw } from '@apis/draws';

export const getDrawQuery = (drawId: string, optionalFields?: string | string[]) =>
  queryOptions({
    queryKey: ['draw', drawId, optionalFields],
    queryFn: ({ signal }) => fetchDraw({ drawId, optionalFields }, signal),
    enabled: !!drawId,
  });
